export default {
    backEndList: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/back-list",
        name: "分拣中心订单列表"
    },
    frontEndList: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/list",
        name: "居民订单列表"
    },
    overviewList: {
        method: "POST",
        url: "/sortingCityAdmin/back-end/overview",
        name: "分拣中心数据概览"
    },
    frontOverviewList: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/overview",
        name: "居民数据概览"
    },
    frontEndtoxicoverview: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/toxic-overview",
        name: "有毒有害数据概览"
    },
    frontGovAbnor: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/gov-abnor",
        name: "审核"
    },
    parentCategory: {
        method: "GET",
        // url: "/v2/order/category/broke/admin-parent-category",
        // 新换接口
        url: "/sortingCityAdmin/front-end/back-cate-list",

        name: "大类"
    },
    categoryNewList: {
        method: "POST",
        url: "/common/category/new-list",
        name: "类目列表"
    },
    toxicList: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/toxic-list",
        name: "有毒有害回收列表"
    },
    sortingList: {
        method: "POST",
        url: "/sortingCityAdmin/back-end/sorting",
        name: "分拣中心列表"
    },
    frontStartTask: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/start-task",
        name: "居民导出"
    },
    backStartTask: {
        method: "POST",
        url: "/sortingCityAdmin/back-end/start-task",
        name: "分拣中心导出"
    },
    backDetail: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/back-detail",
        name: "分拣中心回收订单详情"
    },
    // 大件回收订单列表
    bigOrderList: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/big-order-list",
        name: "大件订单列表"
    },
     // 大件回收订单列表
     bigOrderDetail: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/big-order-detail",
        name: "大件订单详情"
    },
    // 网点管理
    blockList: {
        method: "POST",
        url: "/sortingCityAdmin/front-end/block-list",
        name: "网点管理列表"
    },
};